// public/js/features/files/uploader.css.js
// Styles for the universal uploader, shipped as a string and injected once by
// uploader.js. Kept out of css/app.css so the component stays self-contained
// (drop it into any surface without touching a shared stylesheet). Everything
// else is plain Bootstrap 5; these rules only cover what Bootstrap has no class
// for: the drop zone, the queue row grid and the thumbnails.
// Colours come from the app's design tokens (:root in app.css) with fallbacks.

export const UPLOADER_CSS = `
.sbu-drop {
  border: 2px dashed var(--line, #e5e7eb);
  border-radius: 12px;
  background: #f8fafc;
  padding: 22px 16px;
  text-align: center;
  color: var(--ink-soft, #475569);
  cursor: pointer;
  outline: none;
  transition: border-color .15s ease, background .15s ease, box-shadow .15s ease;
}
.sbu-drop:hover { border-color: #cbd5e1; background: #f1f5f9; }
.sbu-drop:focus-visible,
.sbu-drop.sbu-focus {
  border-color: var(--brand-primary, #2563eb);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, .15);
}
.sbu-drop.sbu-over {
  border-color: var(--brand-primary, #2563eb);
  background: #eff6ff;
  color: var(--brand-primary, #2563eb);
}
.sbu-drop-icon { font-size: 1.6rem; color: #94a3b8; }
.sbu-drop.sbu-over .sbu-drop-icon { color: var(--brand-primary, #2563eb); }
.sbu-drop-hint { font-size: .78rem; color: #94a3b8; }

.sbu-queue { display: flex; flex-direction: column; gap: 8px; }

.sbu-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  border: 1px solid var(--line, #e5e7eb);
  border-radius: 10px;
  padding: 8px 10px;
  background: #fff;
}
.sbu-row.sbu-invalid { border-color: #fecaca; background: #fff5f5; }
.sbu-row.sbu-failed  { border-color: #fed7aa; background: #fffbf5; }
.sbu-row.sbu-done    { border-color: #bbf7d0; background: #f6fffa; }

.sbu-thumb {
  width: 46px; height: 46px; flex: 0 0 46px;
  border-radius: 8px;
  border: 1px solid var(--line, #e5e7eb);
  background: #f1f5f9;
  display: flex; align-items: center; justify-content: center;
  overflow: hidden;
  color: #64748b;
}
.sbu-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }

.sbu-main { flex: 1 1 auto; min-width: 0; }
.sbu-name {
  font-size: .8rem; font-weight: 600; color: var(--ink, #0f172a);
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.sbu-meta { font-size: .72rem; color: #94a3b8; }
.sbu-error { font-size: .72rem; color: #b91c1c; }

/* Label + doc type share one line on desktop, stack on phones. */
.sbu-fields { display: flex; gap: 6px; margin-top: 6px; }
.sbu-fields .form-control,
.sbu-fields .form-select { font-size: .8rem; padding: .25rem .5rem; }
.sbu-fields .sbu-label-input { flex: 1 1 60%; min-width: 0; }
.sbu-fields .sbu-doctype { flex: 1 1 40%; min-width: 0; }

.sbu-row .progress { height: 4px; margin-top: 6px; }
.sbu-actions { display: flex; gap: 4px; flex: 0 0 auto; }

@media (max-width: 575.98px) {
  .sbu-fields { flex-direction: column; }
  .sbu-thumb { width: 38px; height: 38px; flex-basis: 38px; }
  .sbu-drop { padding: 16px 12px; }
}
`;
